import { TwoStepPaymentFormSettings } from 'client/components/core/Sidebar/components/Settings/entities/two-step-payment-form-settings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CustomerTypeInterface } from 'common/types/entities/CustomerTypeInteface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { OrderBumpInterface } from 'common/types/entities/order-bump-interface'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import { TwoStepPaymentFormInterface } from 'common/types/entities/two-step-payment-form-interface'
import React from 'react'
import createCommonEntitySettings from '../createCommonEntitySettings'
import CustomerTypeSettings from './settings/CustomerTypeSettings'
import OfferPriceSettings from './settings/OfferPriceSettings'
import OrderBumpSettings from './settings/order-bump-settings'
import PaymentMethodSettings from './settings/PaymentMethodSettings'

function createSettingsForOfferPage(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.OfferPrice:
      return (
        <OfferPriceSettings
          entity={entity as OfferPriceInterface}
          defaultEntity={defaultEntity as OfferPriceInterface}
        />
      )
    case EntityTypeEnum.CustomerType:
      return (
        <CustomerTypeSettings
          entity={entity as CustomerTypeInterface}
          defaultEntity={defaultEntity as CustomerTypeInterface}
        />
      )
    case EntityTypeEnum.PaymentMethod:
      return (
        <PaymentMethodSettings
          entity={entity as PaymentMethodInterface}
          defaultEntity={defaultEntity as PaymentMethodInterface}
        />
      )
    case EntityTypeEnum.OrderBump:
      return (
        <OrderBumpSettings
          entity={entity as OrderBumpInterface}
          defaultEntity={defaultEntity as OrderBumpInterface}
        />
      )
    case EntityTypeEnum.TwoStepPaymentForm:
      return (
        <TwoStepPaymentFormSettings
          entity={entity as TwoStepPaymentFormInterface}
          defaultEntity={defaultEntity as TwoStepPaymentFormInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForOfferPage
